import React from "react";
import Helmet from "react-helmet";

const Seo = ({ title, description, keywords, slug }) => {
  return (
    <Helmet htmlAttributes={{ lang: `en-US` }}>
      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
      <title>{title}</title>
      <meta name="description" content={description || ""} />

      <link
        hreflang="en-us"
        href={`https://www.legalsections.com${slug || ""}`}
      />

      <link
        rel="canonical"
        href={`https://www.legalsections.com${slug || ""}`}
      />

      <meta name="keywords" content={keywords || ""} />
      <meta
        property="og:site_name"
        data-page-subject="true"
        content="Legalsection"
      />
      <meta property="og:locale" data-page-subject="true" content="en_US" />
      <meta
        property="og:title"
        data-page-subject="true"
        content="Portal for Anything and Everything Linked to the World of Law | Legalsections"
      />
      <meta
        property="og:keyword"
        data-page-subject="true"
        content={keywords || ""}
      />
      <meta property="robots" content="index,follow" />
      <meta
        property="og:description"
        data-page-subject="true"
        content={description || ""}
      />
      <meta property="og:type" data-page-subject="true" content="article" />
      <meta
        property="og:url"
        data-page-subject="true"
        content={`https://www.legalsections.com${
          slug || "https://www.legalsections.com"
        }`}
      />
    </Helmet>
  );
};

export default Seo;
